import { Button } from '@material-ui/core';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { ForgotPasswordContainer } from '../forgot-password';
import { MatField } from 'src/core/components/mat-field';
import { PageError } from 'src/core/components/page-error/page-error';

const emailErrorMap = {
    required: null,
    email: null,
};

interface Props {
    container: ForgotPasswordContainer;
}

export const ForgotPassword = observer<React.SFC<Props>>(({ container: { data } }) => (
    <div className="page page-inverted login-image-background">
        <div className="page-topping">
            <PageError
                absolute
                messageClass={data.emailSent ? 'page-note' : ''}
                message={data.message}
                onClose={data.clearError}
            />
        </div>

        <div className="card">
            <form className="flex-form" onSubmit={data.handleSubmit}>
                <h1>Reset Password</h1>
                <div className="card-content">
                    <p>
                        Enter the email address associated with your account, and we’ll email you a
                        link to reset your password.
                    </p>
                    <div className={classnames('form-field', 'single-input')}>
                        <MatField
                            fullWidth
                            type="email"
                            name="email"
                            placeholder="Email"
                            fieldState={data.email}
                            errorMap={emailErrorMap}
                            disabled={data.emailSent}
                            autoFocus
                        />
                    </div>
                </div>
                <div className="space-filler" />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="next-step-button"
                    disabled={data.form.hasError || data.emailSent}
                >
                    Send Reset Link
                </Button>
            </form>
        </div>
    </div>
));
